import { EWalletTransactionType } from '../types/wallet.types';

export const WalletTransactionTypeMap = {
  [EWalletTransactionType.INBOUND]: {
    name: 'Incoming',
  },
  [EWalletTransactionType.OUTBOUND]: {
    name: 'Outgoing',
  },
};
